var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import { useState, useEffect } from "react";
import "./styles.scss";
import { imageBaseUrl } from "../utils/variables";
var MultiSelectDropdown = function (props) {
    var label = props.label, options = props.options, placeholder = props.placeholder, selectedValue = props.selectedValue, fieldName = props.fieldName, errorMsg = props.errorMsg, validated = props.validated, onChangeHandler = props.onChangeHandler, disabled = props.disabled, isRequired = props.isRequired, tooltipLabel = props.tooltipLabel, styleType = props.styleType;
    var _a = useState(false), isAllSelected = _a[0], updateIsAllSelected = _a[1];
    var _b = useState([]), selectedOption = _b[0], updateSelectedOption = _b[1];
    var _c = useState(false), isOpen = _c[0], updateIsOpen = _c[1];
    var _d = useState(false), isLoading = _d[0], updateIsLoading = _d[1];
    useEffect(function () {
        isLoading && onChangeHandler(fieldName, selectedOption);
        isAllSelected && !selectedOption.length && updateIsAllSelected(false);
        !isAllSelected && selectedOption.length === options.length && selectAll();
    }, [selectedOption]);
    useEffect(function () {
        updateIsLoading(true);
        return function () { return updateIsLoading(false); };
    }, []);
    useEffect(function () {
        preSelectOptions();
    }, [selectedValue, options]);
    var preSelectOptions = function () { return selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.forEach(function (item) {
        var index = options.findIndex(function (option) { return String(option.value) === String(item); });
        index !== -1 && !isOptionSelected(options[index].value) && updateSelectedOption(function (prev) { return __spreadArray(__spreadArray([], prev, true), [options[index]], false); });
    }); };
    var selectAll = function () {
        updateIsAllSelected(!isAllSelected);
        !isAllSelected ?
            options.forEach(function (option) { return !isOptionSelected(option.value) && updateSelectedOption(function (prev) { return __spreadArray(__spreadArray([], prev, true), [option], false); }); }) :
            updateSelectedOption([]);
    };
    var selectOption = function (option) {
        isOptionSelected(option.value) ? resetOption(option) : updateSelectedOption(function (prev) { return __spreadArray(__spreadArray([], prev, true), [option], false); });
    };
    var resetOption = function (option) {
        updateIsAllSelected(false);
        updateSelectedOption(__spreadArray(__spreadArray([], selectedOption.slice(0, selectedOptionIndex(option)), true), selectedOption.slice(selectedOptionIndex(option) + 1), true));
    };
    var removeItem = function (event, option) {
        event.stopPropagation();
        resetOption(option);
    };
    var isOptionSelected = function (value) { return selectedOption.length && selectedOption.some(function (item) { return item.value === value; }); };
    var selectedOptionIndex = function (option) { return selectedOption.findIndex(function (item) { return item.value === option.value; }); };
    return (React.createElement("div", { tabIndex: -1, className: "multi-select-wrapper", onBlur: function () { return updateIsOpen(false); } },
        label && React.createElement("div", { className: "multi-label" }, label),
        React.createElement("div", { className: "multi-list" },
            placeholder &&
                React.createElement("div", { className: "multi-placeholder", onClick: function () { return updateIsOpen(!isOpen); } },
                    selectedOption.length ?
                        React.createElement("div", { className: "multi-selected-list" },
                            React.createElement("div", { className: "selected-list ".concat(selectedOption.length <= 2 ? "count" : "") }, selectedOption.map(function (option, index) { return index < 2 &&
                                React.createElement("div", { key: "".concat(option.value).concat(index, "selected"), title: "".concat(option.name), className: "option-tag" },
                                    React.createElement("span", null, option.name),
                                    React.createElement("img", { onClick: function (event) { return removeItem(event, option); }, width: "14px", alt: "Close", src: "".concat(imageBaseUrl, "/img/icons/close-icon-new.svg") })); })),
                            selectedOption.length > 2 && React.createElement("span", { className: "selected-count" },
                                selectedOption.length - 2,
                                " more"))
                        : React.createElement("span", { className: "select-text" }, "Select ".concat(placeholder)),
                    selectedOption.length > 2 && React.createElement("span", { className: "clear-all", onClick: function (e) { e.stopPropagation(); updateSelectedOption([]); } }, "Clear All"),
                    React.createElement("div", { className: "dropdown-img ".concat(isOpen ? "open" : "") },
                        React.createElement("img", { width: "20px", src: "".concat(imageBaseUrl, "/img/icons/down.svg"), alt: "dropdown-icon", title: "Multi-dropdown" }))),
            isOpen && React.createElement("ul", { className: "multi-list-wrapper" },
                React.createElement("li", { key: "all", className: "multi-list select-all ".concat(isAllSelected ? "selected" : ""), onClick: selectAll },
                    "SELECT ALL",
                    React.createElement("div", { className: "check" })),
                options.map(function (option, index) {
                    return React.createElement("li", { key: "".concat(option.name).concat(index, "option"), className: "multi-list ".concat(isOptionSelected(option.value) ? "selected" : ""), onClick: function () { return selectOption(option); } },
                        option.name,
                        React.createElement("div", { className: "check" }));
                })))));
};
export default MultiSelectDropdown;
//# sourceMappingURL=index.js.map